export const FirebaseConfig = {
	"projectId": "tu-taxi-v",
	"appId": "1:126648401166:web:fe9bba09fd50c6c47ceb5f",
	"databaseURL": "https://tu-taxi-v-default-rtdb.firebaseio.com",
	"storageBucket": "tu-taxi-v.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyBPde3df7SlTFBAkVCFVNlSsyU4pzkwuSg",
	"authDomain": "tu-taxi-v.firebaseapp.com",
	"messagingSenderId": "126648401166",
	"measurementId": "G-EG5D662P7Y"
};